var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-report"},[(_vm.report)?_c('ReportBuilder',{attrs:{"report":_vm.report}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }